import { convertToRaw, EditorState, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import React, { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useSelector } from 'react-redux';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { addressToString } from '@debbie/common/dist/index.js';
import { courts } from '@debbie/common/dist/court/index.js';
import { getContactPerson } from '@debbie/common/dist/customers/index.js';
import { isAdmin, isCaseworker } from '@debbie/common/dist/permissions/index.js';
import { getMentionSuggestions } from '@debbie/common/dist/templates/suggestions.js';
import { DKTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/denmark.js';
import { h } from '@debbie/cortex/dist/index.js';
import * as creditorsAPI from '@debbie/cortex/dist/api/creditors.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
import { selectRole } from '@debbie/cortex/dist/me/selectors.js';
import { selectAllUsers } from '@debbie/cortex/dist/users/selectors.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { Button, SearchInput, Checkbox, Modal, ButtonGroup, } from '../../../index.js';
import { encodeText, parseText } from '../../../../utils/templates.js';
import { getDocumentsFromStorage, setLocalModel, } from './Betalingspaakrav/utils/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import { EmailPreview } from '../../../interactions/index.js';
import { DocumentsPicker } from '../../../documents/index.js';
import { creditorsEntity, useCreditor, } from '@debbie/cortex/dist/creditors/index.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
const localStorageEmailBodyKey = 'fogedRekvisitionEmailHTML';
const Fogedrekvisition = (props) => {
    const lang = useSelector((s) => s.lang);
    const allUsers = useSelector(selectAllUsers);
    const meRole = useSelector(selectRole);
    const singleCase = useSelector((s) => selectCaseById(s, Number(props.caseSeqId)));
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const tenant = useSelector(selectTenant);
    const customer = useSelector((s) => singleCase && selectCustomerById(s, singleCase.customerId));
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.EMAIL, propertyTypes || undefined, tenant);
    const [loading, setLoading] = useState(false);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft.default(encodeText(localStorage.getItem(localStorageEmailBodyKey) || '', mentionSuggestions)).contentBlocks)));
    const [emailBodyEdited, setEmailBodyEdited] = useState(false);
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const contactPerson = customer && getContactPerson(customer);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [court, setCourt] = useState();
    const [documentState, setDocumentReactState] = useState({
        addCourtFeeToCase: true,
        addCourtDisbursementToClientBilling: true,
        addCourtFeeToClientBilling: true,
        sendInfoToEconomyResponsible: true,
        ...getDocumentsFromStorage(),
    });
    const setDocumentState = (addToState) => {
        const newState = {
            ...documentState,
            ...addToState,
        };
        setLocalModel(newState);
        setDocumentReactState(newState);
    };
    const [economyResponsibleUserId, setEconomyResponsibleUserId] = useState(localStorage.economyResponsibleUserId || null);
    useEffect(() => {
        if (creditor?.settings?.courtSubmitConfig?.emailBodyFogedrekvisition) {
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft.default(encodeText(creditor.settings.courtSubmitConfig.emailBodyFogedrekvisition, mentionSuggestions)).contentBlocks)));
        }
    }, [creditor]);
    const getCourt = () => {
        if (court || court === null)
            return court;
        const _court = contactPerson &&
            contactPerson.details.courtId &&
            courts.find((c) => contactPerson.details.courtId &&
                [c.id, c.courtId].includes(contactPerson.details.courtId));
        if (_court) {
            return _court;
        }
    };
    const createFogedrekvisition = async () => {
        if (selectedDocuments.length === 0) {
            confirm('Du har ikke valgt nogen dokumenter til vedhæftning. Er du sikker på, at du vil fortsætte?');
        }
        setLoading(true);
        // Save editorState in localStorage
        const content = editorState
            ? parseText(draftToHtml(convertToRaw(editorState.getCurrentContent())), mentionSuggestions)
            : '';
        // Save in localstorage if creditor has no emailBodyFogedrekvisition
        if (!creditor?.settings?.courtSubmitConfig?.emailBodyFogedrekvisition)
            localStorage.setItem(localStorageEmailBodyKey, content);
        try {
            if (singleCase) {
                await tribunalAPI.createTribunalJob({
                    type: DKTribunalJobType.CreateFogedrekvisition,
                    data: {
                        courtId: getCourt().courtId,
                        fileIds: selectedDocuments.map((d) => d.fileId),
                        sendInfoToEconomyResponsible: documentState.sendInfoToEconomyResponsible,
                        economyResponsibleUserId: economyResponsibleUserId || undefined,
                        addCourtFeeToCase: documentState.addCourtFeeToCase,
                        addCourtFeeToClientBilling: documentState.addCourtFeeToClientBilling,
                        addCourtDisbursementToClientBilling: documentState.addCourtDisbursementToClientBilling,
                        emailBody: parseText(editorState.getCurrentContent().getPlainText(), mentionSuggestions),
                        emailHTML: parseText(draftToHtml(convertToRaw(editorState.getCurrentContent())), mentionSuggestions),
                    },
                    caseId: singleCase.caseId,
                });
                q.invalidate(keys.write.create(tribunalJobsEntity));
                props.onCreated && props.onCreated();
            }
        }
        catch (err) {
            console.error(err);
        }
        setLoading(false);
    };
    const hasBody = () => {
        return !!(editorState &&
            editorState.getCurrentContent() &&
            editorState.getCurrentContent().getPlainText());
    };
    return (React.createElement("div", null,
        React.createElement("h3", null, lang.tribunal.jurisdiction),
        React.createElement(SearchInput, { placeholder: lang.documents.selectCourt, searchAll: (q) => {
                return courts
                    .filter((c) => `${c.name}${c.address}${c.city}${c.email}${c.phone}`
                    .toLowerCase()
                    .indexOf(q.toLowerCase()) !== -1)
                    .map((c) => ({
                    key: c.id,
                    heading: c.name,
                    subheading: addressToString(c),
                    returnData: c,
                }));
            }, static: getCourt() && getCourt().name, onRemoveStatic: () => {
                setCourt({
                    court: null,
                });
            }, onSelect: (court) => {
                setCourt({
                    ...court,
                });
            }, searchDelay: 0, forceOpen: true }),
        React.createElement("h3", null, "Tekst i e-mail"),
        React.createElement(Editor, { stripPastedStyles: true, editorState: editorState, onEditorStateChange: (editorState) => {
                if (!emailBodyEdited)
                    setEmailBodyEdited(true);
                setEditorState(editorState);
            }, mention: {
                separator: ' ',
                trigger: '@',
                suggestions: mentionSuggestions.map((suggestion) => ({
                    value: suggestion.label,
                    text: suggestion.label,
                    url: suggestion.label,
                })),
            } }),
        emailBodyEdited && meRole && isAdmin(meRole) && (React.createElement("p", null,
            React.createElement(Button, { size: "small", onClick: async () => {
                    if (creditor) {
                        setEmailBodyEdited(false);
                        try {
                            await creditorsAPI.update(creditor.creditorId, {
                                settings: {
                                    ...creditor.settings,
                                    courtSubmitConfig: {
                                        ...creditor?.settings.courtSubmitConfig,
                                        emailBodyFogedrekvisition: editorState
                                            ? parseText(draftToHtml(convertToRaw(editorState.getCurrentContent())), mentionSuggestions)
                                            : '',
                                    },
                                },
                            });
                            q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
                        }
                        catch (error) {
                            alert('Error saving');
                        }
                    }
                } }, "Gem tekst p\u00E5 kreditor"))),
        React.createElement("br", null),
        React.createElement("h3", null, lang.tribunal.economy),
        React.createElement(Checkbox, { placeholder: lang.documents.addCourtFeeToCase, checked: documentState.addCourtFeeToCase, onChange: (e) => {
                setDocumentState({
                    ...documentState,
                    addCourtFeeToCase: e.target.checked,
                });
            } }),
        React.createElement(Checkbox, { placeholder: lang.documents.addCourtDisbursementToClientBilling, checked: documentState.addCourtDisbursementToClientBilling, onChange: (e) => {
                setDocumentState({
                    ...documentState,
                    addCourtDisbursementToClientBilling: e.target.checked,
                });
            } }),
        React.createElement(Checkbox, { placeholder: lang.documents.addCourtFeeToClientBilling, checked: documentState.addCourtFeeToClientBilling, onChange: (e) => {
                setDocumentState({
                    ...documentState,
                    addCourtFeeToClientBilling: e.target.checked,
                });
            } }),
        React.createElement(Checkbox, { placeholder: lang.documents.sendInfoAboutRequisitionToRes, checked: documentState.sendInfoToEconomyResponsible, onChange: (e) => {
                setDocumentState({
                    ...documentState,
                    sendInfoToEconomyResponsible: e.target.checked,
                });
            } }),
        documentState.sendInfoToEconomyResponsible && (React.createElement(SearchInput, { searchAll: (q) => allUsers
                ? allUsers
                    .filter((t) => (`${t.firstName} ${t.lastName}`
                    .toLowerCase()
                    .indexOf(q.toLowerCase()) !== -1 ||
                    q.length === 0) &&
                    isCaseworker(t.role))
                    .map((t) => ({
                    key: t.id,
                    heading: `${t.firstName} ${t.lastName}`,
                    subheading: t.role,
                    returnData: t,
                }))
                : [], onSelect: (result) => {
                setEconomyResponsibleUserId(result.id);
                localStorage.setItem('economyResponsibleUserId', result.id ?? '');
            }, static: (() => {
                const user = allUsers &&
                    allUsers.find((t) => t.id === economyResponsibleUserId);
                return ((user && `${user.firstName} ${user.lastName}`) ||
                    economyResponsibleUserId);
            })(), onRemoveStatic: () => {
                setEconomyResponsibleUserId('');
                localStorage.setItem('economyResponsibleUserId', '');
            }, searchDelay: 0, forceOpen: true, placeholder: lang.documents.responsible })),
        singleCase && documents && documents.length > 0 ? (React.createElement(DocumentsPicker, { documents: documents, onChange: (docs) => setSelectedDocuments(docs), caseId: singleCase.caseId })) : (React.createElement("p", null, lang.tribunal.noFoundation)),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { onClick: createFogedrekvisition, loading: loading, disabled: !hasBody() }, lang.tribunal.createFogedrekvisition),
            React.createElement(Button, { theme: "secondary", disabled: !hasBody(), onClick: () => setPreviewModalOpen(!previewModalOpen) }, lang.documents.preview)),
        previewModalOpen && (React.createElement(Modal, { header: lang.documents.preview, onToggle: () => setPreviewModalOpen(!previewModalOpen) }, singleCase && (React.createElement(EmailPreview, { options: {
                caseId: singleCase.caseId,
                html: editorState,
                subject: null,
                mentionSuggestions,
            } }))))));
};
export default Fogedrekvisition;
//# sourceMappingURL=Fogedrekvisition.js.map